<div class="sidenav" 
     [ngClass]="collapsed ? 'sidenav-collapsed' : ''"
     (mouseenter)="expandSidenav()"
     (mouseleave)="collapseSidenav()">
    <div class="logo-container"
        tabindex="0"
        role="button"
        (click)="onLogoClick()">
        <img src="../../../assets/images/Logo_BSP_2024v1-02.svg" alt="Logo" class="logo-img">
        <div class="logo-text" @fadeInOut *ngIf="collapsed">Bext BSP</div>
    </div>
    <div class="scrollwrap scrollwrap_delayed">
        <ul class="sidenav-nav">
            <li class="sidenav-nav-item" *ngFor="let data of navData">
                <a class="sidenav-nav-link" (click)="handleClick(data)"
                    *ngIf="data.items && data.items.length > 0"
                    [ngClass]="getActiveClass(data)">
                    <i class="sidenav-link-icon" [class]="data.icon"></i>
                    <span class="sidenav-link-text" @fadeInOut *ngIf="collapsed">{{data.label}}</span>
                    <i *ngIf="data.items && collapsed" class="menu-collapse-icon"
                        [ngClass]="!data.expanded ? 'fal fa-angle-right':'fal fa-angle-down'"></i>
                </a>
                <a class="sidenav-nav-link"
                    *ngIf="!data.items || (data.items && data.items.length === 0)"
                    [routerLink]="[data.routeLink]"
                    routerLinkActive="active"
                    [routerLinkActiveOptions]="{exact:true}">
                    <i class="sidenav-link-icon" [class]="data.icon"></i>
                    <span class="sidenav-link-text" @fadeInOut *ngIf="collapsed">{{data.label}}</span>
                </a>
                <div *ngIf="collapsed && data.items && data.items.length > 0">
                    <app-sublevel-menu
                        [data]="data"
                        [collapsed]="collapsed"
                        [multiple]="multiple"
                        [expanded]="data.expanded">
                    </app-sublevel-menu>
                </div>
            </li>
        </ul>
    </div>
</div>
